import { render } from "./MyNav.vue?vue&type=template&id=6943502a&scoped=true"
import script from "./MyNav.vue?vue&type=script&lang=js"
export * from "./MyNav.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6943502a"

export default script